import { Link } from "react-router-dom";
import { House, MagnifyingGlass, ArrowRight } from "@phosphor-icons/react";
import SEO from "@/components/SEO";

export default function NotFound() {
  return (
    <>
      <SEO title="Page Not Found" description="The page you're looking for doesn't exist." path="/404" />
      <section className="container-px grid min-h-[78vh] place-items-center py-20 text-center" data-testid="not-found">
        <div>
          <p className="font-heading text-[7rem] sm:text-[10rem] font-black leading-none tracking-tighter text-primary">404</p>
          <h1 className="mt-2 text-3xl sm:text-4xl font-black tracking-tight">This trail leads nowhere</h1>
          <p className="mx-auto mt-3 max-w-md text-muted-foreground">The page you're looking for has pedalled off. Let's get you back on track.</p>
          <div className="mt-8 flex flex-wrap justify-center gap-3">
            <Link to="/" className="btn-primary"><House size={18} /> Back home</Link>
            <Link to="/shop" className="btn-outline"><MagnifyingGlass size={18} /> Browse eBikes <ArrowRight size={16} /></Link>
          </div>
        </div>
      </section>
    </>
  );
}
